import { InformationContent } from "../../../domain/information/InformationContent";
import { InformationId } from "../../../domain/information/InformationId";
import { InformationTitle } from "../../../domain/information/InformationTitle";
import { ApiPaths } from "../../api/ApiPaths";
import { ApiRequest } from "../../api/ApiRequest";

export type GetInformationListSuccessResponseType = {
    informations: [{
        id: string,
        title: string,
        content: string,
        createdTime: string,
        isRead: boolean
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getInformationList(): Promise<GetInformationListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.information.list,
        {},
        () => {},
        () => {});
}

export type GetInformationSuccessResponseType = {
    id: string,
    title: string,
    content: string,
    createdTime: string,
    isRead: boolean,
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getInformation(
    informationId: InformationId
): Promise<GetInformationSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.information.info.replace(/\{informationId\}/g, informationId.value),
        {},
        () => {},
        () => {});
}

export type RegisterInformationSuccessResponseType = {
    id: string,
    title: string,
    content: string,
    createdTime: string,
    isRead: boolean,
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export type RegisterInformationRequestType = {
    title: InformationTitle,
    content: InformationContent,
};

export async function registerInformation(
    body: RegisterInformationRequestType    
): Promise<RegisterInformationSuccessResponseType> {
    return await ApiRequest.post(
        ApiPaths.admin.informationRegister,
        {},
        convertBody(body),
        () => {},
        () => {});
}

export async function deleteInformation(
    informationId: InformationId
) {
    return await ApiRequest.delete(
        ApiPaths.admin.informationDelete.replace(/\{informationId\}/g, informationId.value),
        {},
        () => {},
        () => {});
}

const convertBody = (body: RegisterInformationRequestType) => {
    return {
        title: body.title.value,
        content: body.content.value
    };
};
